// Shared option lists for the image controls on the Generate + Bulk
// screens. Keys MUST match the content-service:
//   graphic model ids → resolveGraphicalEngine()  (image_engine)
//   design style keys → designStyles[]            (design_style)
// '' = Otomatik (backend auto-picks). v0.1.x (2026-07-09).

export type ImageOption = { key: string; tr: string; en: string; note_tr?: string; note_en?: string };

// Graphical models — shown only when image type = Grafik.
// "preferred with fallback": the pick is tried first, then the backend
// falls back to the rest of the roster if it errors/times out.
// NOTE: GPT Image 2 was removed from the picker — at ~185s it always exceeds
// the synchronous ai-gateway budget, times out, and silently falls back to
// Nano Banana 2, so it never actually ran. It is now also PARKED server-side
// (no OpenAI credential) — re-add once an async path AND a key exist.
//
// NOTE: Grok was REMOVED on 2026-08-14. fal.ai was retired in favour of
// direct vendor APIs and the operator chose to drop Grok rather than onboard
// xAI as a new vendor. content-service no longer resolves the "grok" key, so
// a cached bundle still offering it falls back to Otomatik rather than
// erroring — but it must not be offered.
export const GRAPHIC_MODELS: ImageOption[] = [
  { key: "", tr: "Otomatik (önerilen)", en: "Automatic (recommended)", note_tr: "En uygun modeli seçer", note_en: "Picks the best model" },
  // Nexus AI — our own engine, not a third-party model: AI artwork with the
  // headline, logo and CTA rendered on top by our own renderer, so the text
  // is always sharp and the logo is the brand's real one.
  { key: "nexus_ai", tr: "Nexus AI", en: "Nexus AI", note_tr: "Sanat + kusursuz metin · marka logosu", note_en: "Artwork + perfect text · brand logo" },
  // Post-Gemini-migration both Nano Banana engines honour the requested
  // aspect ratio on every lane (4:5, 16:9, 9:16 — not just 1:1), so neither
  // note may carry a ratio caveat ("may render wide" / "(1:1)" are stale).
  { key: "nano-banana-2", tr: "Nano Banana 2", en: "Nano Banana 2", note_tr: "Hızlı · platform oranına uyar", note_en: "Fast · matches the platform ratio" },
  { key: "nano-banana-pro", tr: "Nano Banana Pro", en: "Nano Banana Pro", note_tr: "En yüksek kalite · platform oranına uyar", note_en: "Highest quality · matches the platform ratio" },
];

// Design styles — shown only when image type = Tipografi (text_based).
export const DESIGN_STYLES: ImageOption[] = [
  { key: "", tr: "Otomatik", en: "Automatic" },
  { key: "bold-statement", tr: "Cesur İfade", en: "Bold Statement" },
  { key: "editorial", tr: "Editoryal", en: "Editorial" },
  { key: "modern-gradient", tr: "Modern Gradyan", en: "Modern Gradient" },
  { key: "swiss-minimal", tr: "Sade / İsviçre", en: "Swiss Minimal" },
  { key: "product-spotlight", tr: "Ürün Vitrini", en: "Product Spotlight" },
  { key: "photo-overlay", tr: "Fotoğraf Katmanı", en: "Photo Overlay" },
  { key: "stat-card", tr: "İstatistik Kartı", en: "Stat / Data Card" },
  { key: "testimonial", tr: "Müşteri Yorumu", en: "Testimonial" },
  { key: "carousel-hook", tr: "Karusel Kapağı", en: "Carousel Hook" },
  { key: "festive", tr: "Kutlama / Özel Gün", en: "Festive / Seasonal" },
];
